import { ConfigService } from 'projects/patient/src/app/core/auth/services/config.service';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ActivityLogData,
  ApiResponse,
  ActivityTypesResponse,
  DefaultActivity,
  GoalData,
  UpdateActivityRequest,
  CreateActivityRequest,
  ActivityCategoriesData,
} from '../activity-cosnt/activity-model';

@Injectable({
  providedIn: 'root',
})
export class ActivityService {
  private httpClient = inject(HttpClient);
  private ConfigService = inject(ConfigService);
  private baseUrl = this.ConfigService.getAPIUrl();

  constructor() {}

  getActivityUserAnalyticsOverview(patientId: string): Observable<ApiResponse<GoalData>> {
    return this.httpClient.get<ApiResponse<GoalData>>(
      `${this.baseUrl}/api/activity/user-analytics-overview?patient_id=${patientId}`,
    );
  }

  getActivityAnalyticByDate(
    patientId: string,
    date: string,
  ): Observable<ApiResponse<ActivityLogData>> {
    return this.httpClient.get<ApiResponse<ActivityLogData>>(
      `${this.baseUrl}/api/activity/activity-analytics?patient_id=${patientId}&Date=${date}`,
    );
  }

  getActivityTypes() {
    return this.httpClient.get<ActivityTypesResponse>(
      `${this.baseUrl}/api/activity/activity-types`,
    );
  }

  setDefaultActivity(data: UpdateActivityRequest): Observable<UpdateActivityRequest> {
    return this.httpClient.post<UpdateActivityRequest>(
      `${this.baseUrl}/api/activity/default-activity`,
      data,
    );
  }

  logActivity(data: CreateActivityRequest): Observable<CreateActivityRequest> {
    return this.httpClient.post<CreateActivityRequest>(
      `${this.baseUrl}/api/activity/log-activity`,
      data,
    );
  }

  getCategory(): Observable<ApiResponse<ActivityCategoriesData>> {
    return this.httpClient.get<ApiResponse<ActivityCategoriesData>>(
      `${this.baseUrl}/api/activity/categories`,
    );
  }
}
